/**
 * The drill-through panel: the sidebar shell plus <PersonDetail>. The same body
 * renders on the Employee view page, so the panel and the page can never disagree
 * about a person.
 */
import type { Person, Derived } from '@/data/selectors'
import { PersonDetail } from './PersonDetail'
import { SidePanel } from './SidePanel'

export function DrillThrough({
  person,
  derived,
  openMonths,
  onClose,
  backLabel,
  onBack,
}: {
  person: Person
  derived: Derived
  openMonths: string[]
  onClose: () => void
  backLabel?: string
  onBack?: () => void
}) {
  return (
    <SidePanel onClose={onClose} backLabel={backLabel} onBack={onBack} label={person.employee}>
      <PersonDetail person={person} derived={derived} openMonths={openMonths} />
    </SidePanel>
  )
}
